import { connect } from 'react-redux'
import _ from 'lodash'

import Loading from 'components/loading'

const mapStateToProps = state => ({
  active:
    !state._persist.rehydrated ||
    state.translations.loading ||
    _.isEmpty(state.parameters.json) ||
    _.isEmpty(state.infos.system.json || state.infos.system.error) ||
    _.isEmpty(state.infos.raised.json) ||
    _.isEmpty(state.infos.abilities.json)
})

export default connect(mapStateToProps)(Loading)



// WEBPACK FOOTER //
// ./src/containers/layouts/loading/index.js